<template>
  <!-- ShopRow.vue -->
  <div class="shop_table_row" :class="name" v-on:click.prevent="advanceToDetails()">
    <figure v-if="photo">
      <img v-if="row.PhotoVersion" class="img" :src="photo" />
      <!-- <div class="ribbon" :class="{'collapse': ribbonCollapse}">
              <span>This is a ribbon</span>
            </div>-->
    </figure>
    <figure v-else>
      <div class="filler_shop_image">
        <i class="material-icons dp48">insert_photo</i>
      </div>
    </figure>
    <div class="content">
      <div v-if="containsPartnerExperience && !isPackage">
        <partner-experience-tag style="margin-bottom:8px" />
      </div>
      <span v-if="isPackage" class="text-blue callout">Package</span>
      <h3 class="heading">
        {{ row.Name }}
        <i v-if="row.OfferTransportation" title="Offers Transportation" class="material-icons ml-1 show_dev">directions_bus</i>
        <i v-if="activitiesHaveEnableRateDuration" title="Time Blocks" class="material-icons ml-1 show_dev">av_timer</i>
        <i v-if="row.HasAddOns" title="Add-Ons" class="show_dev material-icons ml-1">library_add</i>
        <i v-if="!row.DisableLargeGroup" title="Large Group" class="show_dev material-icons ml-1">group</i>
        <i v-if="row.Activities[0].EnablePrivateTours" title="Private Tours" class="material-icons ml-1 show_dev">recent_actors</i>
      </h3>
      <div class="p_group">
        <p v-if="row.Activities && !isPackage && !row.OverrideAutoPrice">
          <span>From </span><currency v-if="row.SlashThroughPrice" :class="'slash mr-1'" :value="row.SlashThroughPrice" />
          {{ row.FromPrice }}
          {{ privateToursOnly ? "" : "/ " + row.FromPriceName }}
        </p>
        <p v-if="row.Activities && !isPackage && row.OverrideAutoPrice" v-html="row.DisplayPrice"></p>

        <div v-if="isPackage">
          <p><span v-html="row.DisplayPrice" /><br /><span v-html="row.DisplayDiscount" /></p>
        </div>
      </div>

      <!-- <pre>row: {{ row }}</pre> -->

      <!-- <pre>row.PrivateToursOnly: {{ row.Activities[0].PrivateToursOnly }}</pre> -->
      <!-- <pre>row.DisableLargeGroup: {{ row.DisableLargeGroup }}</pre> -->
      <pre>containsPartnerExperience: {{ containsPartnerExperience }}</pre>
      <pre>row.SlashThroughPrice: {{ row.SlashThroughPrice }}</pre>
      <pre>row.FromPrice: {{ row.FromPrice }}</pre>
      <pre>row.DisplayPrice: {{ row.DisplayPrice }}</pre>
      <pre>row.DisplayDiscount: {{ row.DisplayDiscount }}</pre>
      <pre>row.OverrideAutoPrice: {{ row.OverrideAutoPrice }}</pre>
      <pre>row.Savings: {{ row.Savings }}</pre>

      <shop-row-package :row="row" v-if="isPackage">Package row</shop-row-package>

      <shop-row-individual :row="row" v-else>Activity Row</shop-row-individual>

      <div class="button_footer mt-0">
        <span class="button blue">Book Now</span>
        <span class="flex">
          <span v-if="row.FromPrice">
            From
            <currency :value="row.FromPrice" />&nbsp;each
          </span>
          <i v-if="row.OfferTransportation" class="material-icons ml-1">directions_bus</i>
          <i v-if="row.HasAddOns" class="material-icons ml-1">library_add</i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import ShopRowPackage from "../components/ShopRowPackage.vue";
import ShopRowIndividual from "../components/ShopRowIndividual.vue";
import PartnerExperienceTag from "@/components/PartnerExperienceTag";
//import { mapActions, mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      ribbonCollapse: true,
    };
  },
  props: ["row", "isPackage"],
  components: {
    ShopRowPackage,
    ShopRowIndividual,
    PartnerExperienceTag,
  },
  computed: {
    name() {
      return this.isPackage ? "package-" + this.row.PackageKey : "activity-" + this.row.EntityHierarchyKey;
    },
    //...mapGetters(["logoDark", "logoLight"]),
    containsPartnerExperience() {
      return this.row.Activities.filter((act) => act.Owner_ClientLocationKey).length > 0;
    },
    privateToursOnly() {
      let r = false;
      if (this.row && this.row.Activities) {
        this.row.Activities.forEach((act) => {
          if (act.PrivateToursOnly) {
            r = true;
          }
        });
      }
      return r;
    },

    activitiesHaveEnableRateDuration() {
      var find = this.row.Activities.find((act) => {
        return act.CapacityTypeKey == 2 || act.CapacityTypeKey == 3;
      });

      return find ? true : false;
    },

    productType() {
      return this.isPackage ? "package" : "activity";
    },
    photo() {
      if (this.row.PhotoVersion) {
        return this.row.PhotoDomain + "w_600,h_500,c_fill,f_auto,q_auto" + "/v" + this.row.PhotoVersion + this.row.PhotoFolder + "/original";
      }
      return false;
    },
  },
  mounted() {
    setTimeout(() => {
      this.ribbonCollapse = false;
    }, 100);
  },
  methods: {
    advanceToDetails: function() {
      //this.modal.show = false;
      setTimeout(() => {
        var identifier = this.isPackage ? this.row.PackageKey : this.row.EntityHierarchyKey;
        // identifier += this.row.PackageKey ? `_${this.row.PackageKey}` : '';
        let activityPkg = !this.isPackage && this.row.PackageKey ? this.row.PackageKey : undefined;
        var p =
          "/" +
          this.$route.params.client +
          "/" +
          this.productType +
          "/details/" +
          identifier +
          "/" +
          (this.$route.params.clientAgentKey ? this.$route.params.clientAgentKey + "/start" : "n/start");

        if (activityPkg)
          this.$router.push({
            path: p,
            query: { pkg: this.row.PackageKey },
          });
        else
          this.$router.push({
            path: p,
          });
      }, 50);
    },
  },
};
</script>

<style scoped></style>
